import React, { FC } from 'react';
import { Box, type Theme, useTheme } from '@mui/material';
import { mergeSx } from 'merge-sx';

import { FullTalentQuestionDTOType } from '@/api/generated';
import { borders, transitions } from '@/theme/constants';

interface MultiOptionSymbolProps {
  questionType: FullTalentQuestionDTOType;
  index: number;
}

const ROLE_MAP = {
  [FullTalentQuestionDTOType.CHECKBOX]: 'checkbox',
  [FullTalentQuestionDTOType.RADIO]: 'radio'
} as { [key: string]: string };

const MultiOptionSymbol: FC<MultiOptionSymbolProps> = ({ questionType, index }) => {
  const { spacing } = useTheme();

  return (
    <Box
      aria-disabled="true"
      data-value=""
      role={ROLE_MAP?.[questionType as string]}
      aria-checked="false"
      sx={mergeSx<Theme>(
        {
          borderRadius: spacing(2),
          width: spacing(2),
          height: spacing(2),
          border: borders.default,
          borderColor: 'grey.800',
          mx: 1,
          transition: transitions.borderRadius
        },
        questionType === FullTalentQuestionDTOType.CHECKBOX && {
          borderRadius: spacing(0.5)
        },
        questionType === FullTalentQuestionDTOType.SELECT && {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: 'none',
          width: spacing(2),
          height: spacing(4)
        }
      )}
    >
      {questionType === FullTalentQuestionDTOType.SELECT && `${index + 1}.`}
    </Box>
  );
};

export default MultiOptionSymbol;
